import angular from 'angular';
import reportType from './reportType';
import directive from './report-types.directive';
import controller from './report-types.controller';


export default angular.module('app.components.reports.myReports.reportTypes', [
  reportType
])
  .directive('mrReportTypes', directive)
  .controller('MRReportTypesController', controller)
  .name;

console.log('app.components.reports.myReports.reportTypes created');
